module.exports = __webpack_public_path__ + "img/bluetooth.9d93a16a.svg";